export const safeParse = (probablyJson) => {
    try {
        return JSON.parse(probablyJson);
    } catch (e) {
        // this duplicates the response signature of the scbz api
        // perhaps revisit this to create an signature that
        // error response that matches the api type in use
        // or use a fallback param
        return {
            error: true,
            response: { message: 'API returned invalid JSON data', code: 500 },
        };
    }
};
